import script from "./Chat.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chat.vue?vue&type=script&setup=true&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=5ed70ae5&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed70ae5"]])

export default __exports__